export const sampleRate = 22050;
export const attackSize = 500;
export const releaseSize = 5000;
